const CREATE_METASITE_URL = '/_serverless/domains-storefront-serverless/api/create-metasite';
export const createMetasite = async _ref => {
  let {
    httpClient
  } = _ref;
  const {
    data
  } = await httpClient.post(CREATE_METASITE_URL);
  return data;
};
//# sourceMappingURL=createMetasite.js.map